import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/form";
import { formatDate } from "@/utils/format/date-time";
import { Calendar } from "./calendar/calendar";
import { TimeSlots } from "./time-slots/time-slots";
import { format } from "date-fns";
import { Spinner } from "@/components/ui/spinner";

export const AppointmentTimeCard = ({
    isEdit,
    serviceTitle,
    handleDateChange,
    selectedDate,
    handleTimeChange,
    selectedTime,
    availableDaySet,
    availableTimes,
    onMonthChange,
    isLoading,
}) => {
    return (
        <Card size="lg" className="mb-4 grid-cols-12">
            <div className="col-span-full">
                <h2 className="mb-6 text-xl font-semibold">
                    {isEdit ? "Edit appointment" : "Book appointment"}

                    {serviceTitle && " - " + serviceTitle}
                </h2>
            </div>
            <div className="col-span-full flex max-w-6xl flex-wrap gap-y-6 md:gap-x-8">
                <div className="min-h-90 flex-1 md:max-w-70">
                    <p className="mb-3 text-sm/6 font-medium text-darkgreen-500">
                        Date
                    </p>
                    <div className="relative">
                        <div className="relative flex flex-col items-center md:items-start">
                            <Calendar
                                onChange={handleDateChange}
                                value={selectedDate}
                                tileDisabled={({ date, view }) =>
                                    view === "month" &&
                                    !availableDaySet.has(formatDate(date))
                                }
                                tileClassName={() =>
                                    isLoading
                                        ? "pointer-events-none !opacity-0 select-none"
                                        : ""
                                }
                                onActiveStartDateChange={({
                                    activeStartDate,
                                    action,
                                }) => {
                                    if (
                                        action === "prev" ||
                                        action === "prev2" ||
                                        action === "next" ||
                                        action === "next2" ||
                                        action === "drillDown"
                                    ) {
                                        onMonthChange(
                                            format(activeStartDate, "yyyyMM"),
                                            !isLoading &&
                                                handleDateChange(null),
                                        );
                                    }
                                }}
                            />
                        </div>
                        {isLoading && (
                            <div className="absolute top-35 left-1/2 z-3 -translate-x-1/2">
                                <Spinner />
                            </div>
                        )}
                    </div>
                    <div className="-mx-4">
                        <Input type="hidden" name="date" />
                    </div>
                </div>
                <div className="min-w-60">
                    <p className="mb-3 px-2 text-sm/6 font-medium text-darkgreen-500">
                        Time
                    </p>
                    <div className="max-h-73 overflow-y-auto p-2">
                        <TimeSlots
                            onChange={handleTimeChange}
                            value={selectedTime}
                            availableTimes={availableTimes}
                            availableDaySet={availableDaySet}
                            isLoading={isLoading}
                        />
                    </div>
                    <div className="-mx-2 h-6">
                        <Input type="hidden" name="time" />
                    </div>
                </div>
            </div>
        </Card>
    );
};
